// extracted by mini-css-extract-plugin
export var pillWrapper = "_o8-0";
export var showOverflow = "_o8-1";